// extracted by mini-css-extract-plugin
export default {"cta":"uhkHu2jzw8q7V6DWOUND"};